<template>
  <div id="app">
     <!-- 这里是需要keepalive的 -->
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>

    <!-- 这里不会被keepalive -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <el-dialog
        title=""
        :visible.sync="$store.state.guanjiaEWMShow"
        width="440px"
        :before-close="closeFn"
        :close-on-click-modal = 'false'
        :close-on-press-escape = 'false'
        class="guanjiaDialog"
    >
        <div class="diaBody">
          <div class="kefuIcon">
            <span>专属客服</span>
            <b></b>
          </div>
          <div class="text1">
            添加猿派企业微信
          </div>
          <div class="text2">
            专业人工咨询通道
          </div>
          <div  class="text3">
            1对1快速帮你解决问题，及时满足你的用人匹配需求。
          </div>
          <div  class="imgBox">
            <img :src="$store.state.guanjia" alt="" class="rzLoading">
        
            <div class="rzDesc">
              1对1解答问题
            </div>
          </div>
        
          <div class="btnBox btnBoxRz">
              <a :href="$store.state.guanjia" download="猿派管家二维码.jpg" target="_blank">保存二维码</a>
              <!-- <el-button type="primary" style="width:100%" @click="saveImg">保存二维码</el-button> -->
          </div>
        </div>
        
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
export default {
    name: 'App',
    methods:{
      getGuanjia() {
            window.fdGlobal
                .ajax({
                    method: "POST",
                    url: window.fdConfig.url.rsgl("getGuanjia"),
                    // URL参数
                    // 必须是一个纯对象或者 URL参数对象
                    headers: {
                        "content-type": "application/x-www-form-urlencoded",
                        type: "reward"
                    },
                    data: qs.stringify({ }),
                    //params: '',
                    // 默认值是json
                    responseType: "json"
                })
                .then(
                    data => {
                        if (data.data.code == 1) {
                            localStorage.setItem("guanjia",JSON.stringify(data.data.data))
                            this.$store.state.guanjia = data.data.data.name
                        } else {
                            this.$message.warning(data.data.message);
                        }
                    },
                    data => {
                        this.$message.warning(data.data.message);
                    }
                );
      },
      closeFn(){
        this.$store.state.guanjiaEWMShow=false
      }
    },
    created(){
      
      // localStorage.setItem('userDataToC','{"avatar":"http://test.itjob365.com/ypsaasUpload/default/morentouxiang.png","baseAdminId":null,"baseAdminType":null,"baseChargeId":null,"baseChargeQiyeString":"","baseRewardUserId":null,"baseRewardUserType":null,"baseUserDevice":null,"baseUserGongyingshangRole":null,"baseUserId":null,"baseUserLevel":null,"baseUserParent":null,"baseUserRole":null,"baseUserType":null,"createAdminId":null,"createTime":1648368242000,"deleteStatus":null,"deleteTime":null,"id":37,"mpToken":"","name":"用户3344","password":"","phone":"18519953344","status":0,"token":"3b5df332f052772be4d6b48639ec24664644f158","type":2,"unionid":"","updateTime":1655200468000}')
      // localStorage.setItem('tokenToC','3b5df332f052772be4d6b48639ec24664644f158')
      //  if(localStorage.getItem('tokenToC')){

      // }else{
      //     window.fdGlobal.ajax({
      //       method: 'POST',
      //       url: window.fdConfig.url.login('login'),
      //       // URL参数
      //       // 必须是一个纯对象或者 URL参数对象
      //       headers: { 'content-type': 'application/x-www-form-urlencoded' ,type:'reward'},
      //       data: qs.stringify({
      //         phone : '18519953344',
      //         password : 'qwer123456'
      //       }),
      //       //params: '',
      //       // 默认值是json
      //       responseType: 'json'
      //   }).then((data) => {
          
      //       if(data.data.code==1){
              
              
             
      //       }else{
      //           this.$message.warning(data.data.message);
      //       }
            
      //   }, (data) => {
      //       this.$message.warning(data.data.message);
      //   });
      // }
      this.getGuanjia()
    }
};
</script>

<style lang="less">
  #app{
    width: calc(100% + 1px);
    position: relative;
    left: -1px
  }
  @import "./css/index.less";
  // *{
  //   font-family: 'Source Han Sans CN';
  // }
  .el-message{
    z-index: 99999999999 !important;
  }
  .el-tooltip__popper{
    max-width: 300px;
  }
  .el-message-box{
    .el-button--primary{
      color: #fff !important;
    }
  }
  .el-dialog{
    border-radius: 8px;
  }
  .renzhengTip{
    max-width: 330px;
  }
  .guanjiaDialog{
    .el-dialog{
      background: linear-gradient(171deg, #D5F2FF 4.04%, #F8F8FA 61.16%);
      border-radius: 8px;
      .el-dialog__body{
         position: relative;
        .kefuIcon{
          position: absolute;
          top: -2px;
          background: #F52A2A;
          border-radius: 2px;
          width: 56px;
          font-size: 12px;
          color: #fff;
          font-weight: 700;
          line-height: 21px;
          b{
            position: absolute;
            bottom: -5px;
            left: 0;
            width: 0;
            height: 0;
            border: 5px solid #F52A2A;
            border-top-color: rgba(0, 0, 0, 0.00);
            border-bottom-color: rgba(0, 0, 0, 0.00);
            border-right-color: rgba(0, 0, 0, 0.00);
          }
        }
      }
    }
    img{
      width: 200px;
      height: 200px;
      margin-top: 20px;
    }
    .text1{
      font-size: 24px;
      font-weight: 900;
      color: #262F47;
      text-align: left;
    }
    .text2{
      margin-top: 8px;
      font-size: 14px;
      color: #262F47;
      text-align: left;
    }
    .text3{
      color: #BFC1CE;
      font-size: 14px;
      margin-top: 4px;
      text-align: left;
    }
    .imgBox{
      width: 392px;
      height: 264px;
      background: #fff;
      margin-top: 24px;
      margin-bottom: 24px;
      border-radius: 8px;
    }
    .rzTit{
      color: #262F47;
      font-size: 18px;
      font-weight: 800;
      margin-top: 24px;
    }
    .rzDesc{
      color: #51596C;
      font-size: 14px;
      margin-top: 4px;
     
    }
    a{
      display: inline-block;
      width: 100%;
      height: 44px;
      background: #30333D;
      line-height: 44px;
      color: #fff;
      font-weight: 700;
    }
  }
  .editTip{
    position: relative;
    margin-top: 0;
    margin-right: -15px;
    animation-name: likes; // 动画名称
		animation-direction: alternate; // 动画在奇数次（1、3、5...）正向播放，在偶数次（2、4、6...）反向播放。
		animation-timing-function: linear; // 动画执行方式，linear：匀速；ease：先慢再快后慢；ease-in：由慢速开始；ease-out：由慢速结束；ease-in-out：由慢速开始和结束；
		animation-delay: 0s; // 动画延迟时间
		animation-iteration-count: infinite; //  动画播放次数，infinite：一直播放
		animation-duration: 1s; // 动画完成时间
    .popper__arrow{
      margin-right: -5px;
    }
  }
  .wall2{
    position: relative;
    left: -84px;
    animation-name: likes2; // 动画名称
		animation-timing-function: linear; // 动画执行方式，linear：匀速；ease：先慢再快后慢；ease-in：由慢速开始；ease-out：由慢速结束；ease-in-out：由慢速开始和结束；
		animation-delay: 0s; // 动画延迟时间
		animation-iteration-count: infinite; //  动画播放次数，infinite：一直播放
		animation-duration: 120s; // 动画完成时间
    .popper__arrow{
      margin-right: -5px;
    }
  }
  .cardMoveClass{
    animation-name: cardMove; // 动画名称
		animation-timing-function: linear; // 动画执行方式，linear：匀速；ease：先慢再快后慢；ease-in：由慢速开始；ease-out：由慢速结束；ease-in-out：由慢速开始和结束；
		animation-delay: 0s; // 动画延迟时间
		
		animation-duration: 500ms; // 动画完成时间
  }
  .orderConfirm{
    padding: 24px !important;
    .el-message-box__header{
      padding: 0;
      .el-message-box__headerbtn{
        display: none;
      }
      
    }
    .el-message-box__btns{
      display: flex;
      padding: 0;
      margin-top: 28px;
      .el-button{
        flex: 1;
        height: 44px;
      }
    }
  }
  @keyframes likes {
    0%{
      -webkit-transform: translate3d(0,-10px,0)
    }
    100%{
      -webkit-transform: translate3d(0,0px,0)
    }
  }
  @keyframes likes2 {
    0%{
      left: 0;
    }
    100%{
      left: -6620px;
    }
  }
  @keyframes cardMove {
    0%{
      left: 50%;
      top: 50%;
    }
    100%{
      left: -1000px;
      top: 1000px;
    }
  }
  .cancelPop{
    min-width: 100px !important;
  }
  .el-loading-mask{
    z-index: 99999 !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue